import { useAtomValue } from 'jotai'
import React from 'react'
import { match } from 'ts-pattern'

import { dialogInfoAtom } from '../atoms'

import { BrandSettingsDialog } from './BrandSettingsDialog'
import { CustomerAttributeGroupSettingsDialog } from './CustomerAttributeGroupSettingsDialog'
import { DeleteSurveyGroupDialog } from './DeleteSurveyGroupDialog'
import { EditSurveyGroupDialog } from './EditSurveyGroupDialog'
import { QuestionSettingsDialog } from './QuestionSettingsDialog'
import { SurveySettingsDialog } from './SurveySettingsDialog'

export const Dialogs = () => {
  const dialogInfo = useAtomValue(dialogInfoAtom)

  return match(dialogInfo?.dialogType)
    .with(undefined, () => null)
    .with('create', 'update', () => <EditSurveyGroupDialog />)
    .with('delete', () => <DeleteSurveyGroupDialog />)
    .with('surveySettings', () => <SurveySettingsDialog />)
    .with('brandSettings', () => <BrandSettingsDialog />)
    .with('questionSettings', () => <QuestionSettingsDialog />)
    .with('customerAttributeGroupSettings', () => (
      <CustomerAttributeGroupSettingsDialog />
    ))
    .exhaustive()
}
